module.exports = __webpack_public_path__ + "static/media/posterM-1.6ec08890.png";